<template>
  <el-date-picker
    class="hc-date-picker-custom__container"
    v-model="config.value"
    :default-time="['00:00:00', '23:59:59']"
    :type="config.datePickerType || 'daterange'"
    range-separator="至"
    :start-placeholder="config.startPlaceholder || '开始日期'"
    :end-placeholder="config.endPlaceholder || '结束日期'"
    :clearable="!config.noCleara"
    unlink-panels
    :value-format="config.format || 'yyyy-MM-dd HH:mm:ss'"
    :disabled="config.disabled"
    @change="changePicker"
    :picker-options="pickerOptions"
  />
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DatePickerCustom',
  props: {
    config: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['utcTimeOffset']),
    timeZone() {
      return this.config.timeZone === undefined ? 8 : this.config.timeZone
    },
  },
  data() {
    return {
      pickerDate: {},
      defaultShortcuts: {
        today: {
          text: '今天',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.startOf('day').toDate()
            const end = bjcTime.endOf('day').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        yesterday: {
          text: '昨天',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.add(-1, 'day').startOf('day').toDate()
            const end = bjcTime.add(-1, 'day').endOf('day').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        latest7days: {
          text: '最近7天',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.add(-6, 'day').toDate()
            const end = bjcTime.toDate()
            picker.$emit('pick', [start, end])
          },
        },
        thisWeek: {
          text: '本周',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.startOf('week').add(1, 'day').toDate()
            const end = bjcTime.toDate()
            picker.$emit('pick', [start, end])
          },
        },
        lastWeek: {
          text: '上周',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.add(-1, 'week').startOf('week').add(1, 'day').toDate()
            const end = bjcTime.add(-1, 'week').endOf('week').add(1, 'day').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        latest30days: {
          text: '最近30天',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.add(-29, 'day').toDate()
            const end = bjcTime.toDate()
            picker.$emit('pick', [start, end])
          },
        },
        thisMonth: {
          text: '本月',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.startOf('month').toDate()
            const end = bjcTime.toDate()
            picker.$emit('pick', [start, end])
          },
        },
        lastMonth: {
          text: '上月',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.add(-1, 'month').startOf('month').toDate()
            const end = bjcTime.add(-1, 'month').endOf('month').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        last3months: {
          text: '最近三个月',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.add(-2, 'month').startOf('month').toDate()
            const end = bjcTime.toDate()
            picker.$emit('pick', [start, end])
          },
        },
        currentSeason: {
          text: '本季度',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.startOf('quarter').toDate()
            const end = bjcTime.toDate()
            picker.$emit('pick', [start, end])
          },
        },
        thisQuarter: {
          text: '上季度',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.add(-1, 'quarter').startOf('quarter').toDate()
            const end = bjcTime.add(-1, 'quarter').endOf('quarter').toDate()
            picker.$emit('pick', [start, end])
          }
        },
        tomorrow: {
          text: '明天',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.add(1, 'day').startOf('day').toDate()
            const end = bjcTime.add(1, 'day').endOf('day').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        latest7daysFuture: {
          text: '最近7天',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.toDate()
            const end = bjcTime.add(6, 'day').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        thisWeekFuture: {
          text: '本周',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.toDate()
            const end = bjcTime.endOf('week').add(1, 'day').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        nextWeek: {
          text: '下周',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.add(1, 'week').startOf('week').add(1, 'day').toDate()
            const end = bjcTime.add(1, 'week').endOf('week').add(1, 'day').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        latest30daysFuture: {
          text: '最近30天',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.toDate()
            const end = bjcTime.add(29, 'day').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        thisMonthFuture: {
          text: '本月',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.toDate()
            const end = bjcTime.endOf('month').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        nextMonth: {
          text: '下月',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.add(1, 'month').startOf('month').toDate()
            const end = bjcTime.add(1, 'month').endOf('month').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        last3monthsFuture: {
          text: '最近三个月',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.toDate()
            const end = bjcTime.add(2, 'month').endOf('month').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        currentSeasonFuture: {
          text: '本季度',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.toDate()
            const end = bjcTime.endOf('quarter').toDate()
            picker.$emit('pick', [start, end])
          },
        },
        nextQuarter: {
          text: '下季度',
          onClick: (picker) => {
            const bjcTime = this.$cTime().add(8, 'h')
            const start = bjcTime.add(1, 'quarter').startOf('quarter').toDate()
            const end = bjcTime.add(1, 'quarter').endOf('quarter').toDate()
            picker.$emit('pick', [start, end])
          }
        },
      },
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: (time) => {
          const timeValue = time.getTime()
          const pickerDate = this.pickerDate
          const { maxChange, subtractDay, endTime, infinite } = this.config
          let maxTime = infinite
            ? 9999999999999
            : this.$cTime()
              .add(this.timeZone, 'h')
              .endOf('day')
              .valueOf()
          let minTime = 0
          if (endTime) {
            maxTime = this.$dayjs(endTime)
              .endOf('day')
              .valueOf()
          }
          if (pickerDate?.minDate && !pickerDate.maxDate) {
            // 最大选取周期
            if (maxChange) {
              const maxChange_max = this.$dayjs(pickerDate.minDate)
                .add(maxChange[0], maxChange[1])
                .startOf('day')
                .valueOf()
              const maxChange_min = this.$dayjs(pickerDate.minDate)
                .subtract(maxChange[0], maxChange[1])
                .startOf('day')
                .valueOf()
              if (maxChange_max < maxTime) {
                maxTime = maxChange_max
              }
              if (maxChange_min > minTime) {
                minTime = maxChange_min
              }
            }
          }
          if (subtractDay) {
            // 能选择的最大周期
            const minTime_min = this.$cTime()
              .add(this.timeZone, 'h')
              .subtract(subtractDay[0], subtractDay[1])
              .startOf('day')
              .valueOf()
            if (minTime_min > minTime) {
              minTime = minTime_min
            }
          }
          return timeValue >= maxTime || timeValue <= minTime
        },
        shortcuts: [],
        onPick: (obj) => {
          this.pickerDate = obj
        },
      },
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.initShortcuts()
    },
    initShortcuts() {
      const { showShortcuts = true } = this.config
      if (!showShortcuts) {
        // 不要快捷菜单
        this.pickerOptions.shortcuts = null
        return
      }

      const defaultShortcuts = this.config.shortcuts || [
        'today',
        'yesterday',
        'latest7days',
        'thisWeek',
        'lastWeek',
        'latest30days',
        'thisMonth',
        'lastMonth',
        'last3months',
        'currentSeason',
        'thisQuarter',
      ]

      const newArr = []
      defaultShortcuts.forEach(key => {
        const findObj = this.defaultShortcuts[key]
        if (findObj) {
          newArr.push(findObj)
        }
      })

      this.pickerOptions.shortcuts = newArr
    },
    changePicker(value) {
      this.$emit('handleDateChange', this.config, value)
    },
  },
}
</script>

<style lang="scss" scoped>
.quick-warp {
  display: flex;
}
.label-box {
  padding: 6px 12px;
  border: 1px solid $G4;
  border-right: none;
  color: $G9;
  font-size: 13px;
  border-radius: 2px 0 0 2px;
}
.Flex {
  display: flex;
  align-items: center;
}
// 至 垂直居中
.hc-date-picker-custom__container.el-range-editor.el-input__inner ::v-deep .el-range-separator {
  font-size: 13px;
  line-height: 24px;
}
</style>
